import {Component, Mixins, Vue} from 'vue-property-decorator'
import {ITravel} from "@/entities";

@Component
class resolveImageMixin extends Vue {
    protected resolveImageURL(url: string): string {
        let images = require.context('../assets/img/', false)
        return images('./' + url);
    }
}

@Component
export class resolveTravelImageMixin extends Mixins(resolveImageMixin) {
    get travel(): ITravel | null | undefined {
        return null;
    }
    get backgroundUrl(): string {
        return this.travel?.general_image.file || this.resolveImageURL('placeholder.travel.jpg');
    }
}

export default resolveImageMixin
